import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */
export var ActivityReceivedEventArgs = /*#__PURE__*/function () {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {any} activity - The activity..
   */
  function ActivityReceivedEventArgs(activity, audioStream) {
    _classCallCheck(this, ActivityReceivedEventArgs);

    this.privActivity = activity;
    this.privAudioStream = audioStream;
  }
  /**
   * Gets the received activity
   * @member ActivityReceivedEventArgs.prototype.activity
   * @function
   * @public
   * @returns {any} the received activity.
   */


  _createClass(ActivityReceivedEventArgs, [{
    key: "activity",
    get: function get() {
      return this.privActivity;
    }
  }, {
    key: "audioStream",
    get: function get() {
      return this.privAudioStream;
    }
  }]);

  return ActivityReceivedEventArgs;
}();